module.exports = __webpack_public_path__ + "35034714755b77faa203d06529ce1b26.svg";